import './polyfill/polyfill-nodelist-foreach'
import './polyfill/polyfill-console'
import './polyfill/polyfill-custom-event'

import './tracking/ga4'
import './tracking/algolia'

import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import morph from '@alpinejs/morph'

Alpine.plugin(intersect)
Alpine.plugin(morph)

// alpine components (data) must be declared before Alpine.start

import './shared-imports'
import './component/add-to-wishlist'
import './component/add-to-cart'
import './component/login-form'
import './component/buy-now-preview'
import './component/variant-select'
import './component/video-player'
import './component/video-player-mp4'
import './component/slider'
import './component/scroll-stage'
import './component/product-sprite'
import './component/product-360'
import './component/product-media'
import './component/ratepay-installments'

document.addEventListener('alpine:init', () => {
    document.dispatchEvent(new Event('alpine:bundle'))
})

window.Alpine = Alpine
Alpine.start()

import './misc/legacy-link-decoder'